// extracted by mini-css-extract-plugin
export default {"myLoadingIcon":"MyLoadingIcon_myLoadingIcon__ARhXD","myLoadingIconWrapper":"MyLoadingIcon_myLoadingIconWrapper__IFJcX","spin":"MyLoadingIcon_spin__aa1qA"};